<script setup>
import { useAlertDialog } from '@/utils/stores/alertDialog'

const alertDialogStore = useAlertDialog()

const { alertDialogMessage, alertDialogTimeout } = storeToRefs(alertDialogStore)
</script>

<template>
  <VDialog
    v-model="alertDialogStore.alertDialogShow"
    class="v-dialog-sm"
  >
    <VCard :title="alertDialogStore.alertDialogTitle ? alertDialogStore.alertDialogTitle : ''">
      <!-- <VCardText>{{ alertDialogMessage }}</VCardText> -->
      <VCardText
        class="d-flex align-center flex-wrap"
        :class="alertDialogTimeout==0 ? 'justify-space-between' : 'justify-center'"
      >
        <VCol
          cols="10"
          class="font-weight-bold"
        >
          <p
            style="margin-block-end:0px"
            v-html="alertDialogMessage"
          />
        </VCol>
        <!--
          <VProgressCircular
          v-if="alertDialogTimeout!=0"
          indeterminate
          color="primary"
          :size="30"
          />
        -->
        <!--
          </VCardText>
          <VCardText>
        -->
        <VCol cols="2">
          <VBtn
            v-if="alertDialogTimeout==0"
            @click="alertDialogStore.alertDialogShow = false"
          >
            Close
          </VBtn>
        </VCol>
      </VCardText>
    </VCard>
  </VDialog>
</template>
